import J7UpdateDetail from './J7UpdateDetail';

export default J7UpdateDetail;
